import { defineMessages } from 'react-intl';

export default defineMessages({
    title: {
        id: '_.apply_flexi_loan.newDocUploads.bankStatements.title',
        defaultMessage: '{strongText} for the last {duration}'
    },
    subtitle: {
        id: '_.apply_flexi_loan.newDocUploads.bankStatements.subtitle',
        defaultMessage: 'How would you like to share these?'
    },
    manualUploadTitle: {
        id: '_.apply_flexi_loan.newDocUploads.BankStatements.manualUpload.manualUploadTitle',
        defaultMessage: 'Upload statements manually'
    },
    firstBullet: {
        id: '_.apply_flexi_loan.newDocUploads.BankStatements.manualUpload.first_bullet',
        defaultMessage: 'We accept PDF statements.'
    },
    secondBullet: {
        id: '_.apply_flexi_loan.newDocUploads.BankStatements.manualUpload.second_bullet',
        defaultMessage:
            'Your transactions must cover the stated period and be from the accounts(s) where the majority of your business revenue is generated'
    },
    linkTrueLayer: {
        id: '_.apply_flexi_loan.newDocUploads.BankStatements.manualUpload.link_true_layer',
        defaultMessage:
            'We also offer Open Banking, a secure way to share your business banking data without sharing your password.'
    },
    linkTrueLayerCTA: {
        id: '_.apply_flexi_loan.newDocUploads.BankStatements.manualUpload.link_true_layer_cta',

        defaultMessage: 'Link my bank account'
    },
    point3: {
        id: '_.apply_flexi_loan.newDocUploads.BankStatements.manualUpload.point3',
        defaultMessage:
            'Your transactions must cover the stated period and be from the accounts(s) where the majority of your business revenue is generated'
    },
    point4: {
        id: '_.apply_flexi_loan.newDocUploads.BankStatements.manualUpload.point4',
        defaultMessage:
            'Your transactions must cover the stated period and be from the accounts(s) where the majority of your business revenue is generated'
    },
    point5: {
        id: '_.apply_flexi_loan.newDocUploads.BankStatements.manualUpload.point5',
        defaultMessage:
            'Your transactions must cover the stated period and be from the accounts(s) where the majority of your business revenue is generated'
    },
    point6: {
        id: '_.apply_flexi_loan.newDocUploads.BankStatements.manualUpload.point6',
        defaultMessage:
            'Your transactions must cover the stated period and be from the accounts(s) where the majority of your business revenue is generated'
    },
    selectOptionLabel: {
        id: '_.apply_flexi_loan.newDocUploads.BankStatements.selectOptionLabel',
        defaultMessage:
            'Select an option below to manually upload bank statements'
    }
});
